<template>
  <div class="good-zoom">
      <div class="good-zoom-container">
          <div class="zoom">

              <img v-if="image" :src="image.raw+'?w=500&h=500'">
              <img v-else :src="altUrlSmall">
          </div>
          <ul class="images" v-if="item.images && item.images.length >1">
              <template v-for="image in item.images">
			    <li @click="showImage(image)" :style="{ backgroundImage: `url('${image.raw}')`}">
              </li>
            </template>
          </ul>
      </div>
  </div>
</template>

<script>
    import jqueryZoom from 'jquery-zoom'
	
    export default {
        name: 'GoodZoom',
        props: ['item'],

        data() {
            return {
                image: false,
                altUrlSmall: "",
                altUrl: ""
            }
        },
		
        activated: function() {
            this.image = (this.item.images) ? this.item.images[0] : false;
        },
		
        deactivated: function() {
            this.image = false;
        },
		
        watch: {
            "item": function() {
                this.image = (this.item.images) ? this.item.images[0] : false;
                this.altUrlSmall = "https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/" + this.item.id + ".jpg"
                this.altUrl = "https://res.cloudinary.com/mwsuite/image/upload/product/" + this.item.id + ".jpg"

            },
            "image": function() {

                this.showImage(this.image);
            }
        },
		
        methods: {
            showImage(image) {
                var self = this;
                this.image = image
                var url = (this.image) ? this.image.raw : this.altUrl
                $('.zoom').trigger('zoom.destroy'); // remove zoom
                $('.zoom').zoom({
                    url: url
                });
            }
        }
    }
</script>

<style scoped>
    .good-zoom{
        margin-top: 15px;
    }
    .good-zoom .good-zoom-container{
        display: flex;
        width:100%;
    }
    .good-zoom .images{
        list-style: none;
        margin: 0px 0 15px 0;
        padding: 0;
        display: flex;
        flex-direction: column;
    }
    .good-zoom .images li{
        display: inline-block;
        padding: 15px;
        border: 1px solid #ccc;
        margin-right: 10px;
        cursor: pointer;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        width: 100px;
        height: 100px;
    }
    .good-zoom .images li img{
        width: 85px;
        height: 125px;
    }
    .good-zoom .zoom{
        max-width: 100%;
        width: 100%;
        height: 500px;
        border: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px;
    }
    @media screen and (max-width: 767px){
        .good-zoom .good-zoom-container{
            flex-direction: column;
        }
        .good-zoom .images{
            flex-direction: row;
            margin: 10px 0 25px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// GoodZoom.vue?4c407876